module.exports = __webpack_public_path__ + "static/media/mail.d9ef1a05.svg";